import React from "react";

const FOR = [
    "You're 45 or older and thinking seriously about retirement.",
    "You've saved real money and you don't want to lose it to inflation, bad tax policy, or a market you can't predict.",
    "You're tired of financial media that treats you like either a sucker or a day-trader.",
    "You want plain talk, not \u201Cstay the course\u201D platitudes.",
];

const NOT_FOR = [
    "You want hot stock tips or trade alerts.",
    "You think \u201Cdiversification\u201D means owning ten S&P 500 index funds.",
    "You believe the financial press is doing its job.",
];

export default function WhoItsFor() {
    return (
        <section
            id="who-its-for"
            className="bt-section"
            data-testid="section-who-its-for"
            style={{ borderTop: "1px solid var(--bt-rule)" }}
        >
            <div className="bt-shell">
                <div
                    className="bt-promise-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 32,
                        marginBottom: 56,
                    }}
                >
                    <aside style={{ paddingTop: 14 }}>
                        <p className="signal" style={{ marginBottom: 14 }}>
                            № 05
                        </p>
                        <p className="marginalia" style={{ margin: 0, color: "var(--bt-mute)" }}>
                            Reader profile
                        </p>
                    </aside>
                    <div className="bt-read">
                        <h2 className="t-display" style={{ margin: 0, marginBottom: 16 }}>
                            Who reads Brass Tacks Brief.
                        </h2>
                        <p className="t-lede" style={{ margin: 0 }}>
                            Two short lists. If the left list reads like a description
                            of you and the right list does not, the brief is for you.
                        </p>
                    </div>
                </div>

                <div
                    className="bt-who-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 56,
                        alignItems: "start",
                    }}
                >
                    <Column heading="It’s for you if" items={FOR} accent testid="who-for" />
                    <Column heading="It’s not for you if" items={NOT_FOR} testid="who-not-for" />
                </div>
            </div>
        </section>
    );
}

function Column({ heading, items, accent = false, testid }) {
    return (
        <div data-testid={testid}>
            <p
                className="signal"
                style={{
                    marginBottom: 18,
                    color: accent ? "var(--bt-brass)" : "var(--bt-mute)",
                }}
            >
                {heading}
            </p>
            <ul
                role="list"
                style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    borderTop: `1px solid ${accent ? "var(--bt-ink)" : "var(--bt-rule)"}`,
                }}
            >
                {items.map((it, i) => (
                    <li
                        key={i}
                        className="t-body"
                        style={{
                            paddingTop: 22,
                            paddingBottom: 22,
                            borderBottom: "1px solid var(--bt-rule)",
                            color: accent ? "var(--bt-ink)" : "var(--bt-ink-soft)",
                            fontSize: 17,
                            lineHeight: 1.5,
                        }}
                    >
                        {it}
                    </li>
                ))}
            </ul>
        </div>
    );
}
